import { defineStore } from 'pinia'
import { reactive, ref } from 'vue'

export const useMainElement = defineStore('mainElement',()=>{
    const mainElement = ref< HTMLElement|undefined>(undefined)
    function setMainElement(html?: HTMLElement){        
        mainElement.value = html
    }
    return {element:mainElement,setMainElement}
})